var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPath10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 473.501,
    height: 1602.737,
    viewBox: "0 0 473.501 1602.737",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#683c11;stroke-linecap:round;stroke-width:10px;stroke-dasharray:20 35;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M644.585,3193s-52.872,110.058,0,234.552,254.631,45.739,256.715,156.568-365.824,94.29-359.556,221.193,466.238,137.047,463.411,266.858-292.624,82.2-313.442,183.438,92.738,228.308,142.565,320.509-176.48,88.648-223.173,133.312,0,72.771,0,72.771",
    transform: "translate(-536.668 -3186.328)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath10);
export default __webpack_public_path__ + "static/media/Path10.f72099b0268b55ff4a982ec96c2d469f.svg";
export { ForwardRef as ReactComponent };